<template>
  <div class="dialog-detail">
    <el-dialog
      v-model="isDetail"
      :lock-scroll="false"
      width="654px"
      @close="handleClose"
    >
      <template #title>
        <span class="font-20 font-w-bold color-black flex-grow-1">
          Request Detail
        </span>
      </template>
      <el-table
        :data="data"
        :show-header="false"
        size="small"
        stripe
        style="width: 100%"
      >
        <el-table-column prop="title" label="Title" width="130" />
        <el-table-column prop="value" label="Value" />
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="btn-full-block font-w-bold"
            @click="handleClose"
          >
            Close
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'

const props = defineProps({
  modelValue: {
    required: false
  },
  detail: {
    required: false
  }
})

const emit = defineEmits(['update:modelValue'])

const isDetail = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
const data = computed(() => {
  return props.detail
})
const handleClose = () => {
  isDetail.value = false
}
</script>

<style lang="scss">
.dialog-detail {
  & .el-overlay {
    z-index: 3000 !important;
  }
  & .el-dialog {
    border-radius: 10px !important;
    & .el-dialog__body {
      padding: 10px !important;
    }
  }
}
</style>
